import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IVehicleModel {
  id: number
  title: string
  code: string
  status: number
  delf: number
  categoryCarId: number
  categoryCarTitle: string
  carLineId: number
  carLineTitle: string
  typeVehicleId: number
  typeVehicleTitle: string
  groupVehicleId?: number
  groupVehicleTitle: string
  productVehicleId?: number
  productVehicleTitle: string
}

export const getListVehicleModel = async (
  limit?: number, pageNumber?: number, search?: string, carLineId?: number,
  typeVehicleId?: number, categoryCarId?: number
) => {
  const path = "vehicleModel/listVehicleModel"
  const params = {
    limit, pageNumber, search, carLineId,
    typeVehicleId, categoryCarId
  }
  const result: ResponseSuccessTotal<IVehicleModel[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin dòng xe
export const getInfoVehicleModel = async (
  id: number
) => {
  const path = "vehicleModel/infoVehicleModel"
  const params = {
    id
  }
  const result: ResponseSuccess<IVehicleModel> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Thêm mới mẫu xe
export const addVehicleModel = async (
  title: string, code: string, idCarlines: number,
  idCategoryCar: number, idTypeVehicle?: number,
  idGroupVehicle?: number, idProductVehicle?: number
) => {
  const url = `vehicleModel/addVehicleModel`;
  const params = {
    title, code, idCarlines, idTypeVehicle,
    idCategoryCar,
    idGroupVehicle, idProductVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa dòng xe
export const editVehicleModels = async (
  id: number, title: string, code: string, idCarlines: number,
  idTypeVehicle: number, idCategoryCar: number,
  idGroupVehicle?: number, idProductVehicle?: number
) => {
  const url = `vehicleModel/editVehicleModel`;
  const params = {
    id, title, code, idCarlines,
    idTypeVehicle, idCategoryCar,
    idGroupVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa dòng xe
export const deleteVehicleModels = async (
  id: Number[]
) => {
  const url = `vehicleModel/deleteVehicle`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveVehicleModel = async (
  id: number
) => {
  const path = "vehicleModel/activeVehicle"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
